/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

const retailMenuServices = {
	gateway,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CREATE':
			return createMenu({ req });
		case 'VIEW':
			return viewMenu({ req });
		case 'LIST':
			return listMenus({ req });
		case 'UPDATE':
			return updateMenu({ req });
		case 'DELETE':
			return deleteMenu({ req });
		default:
			break;
	}
	return new Promise(() => {});
}

function createMenu({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ ...req.data }),
	};
	return fetch(endpoints.RETAIL_MENU, requestOptions).then(handleResponse);
}

function updateMenu({ req }) {
	// BE reads the menu id from the body.
	req.data.id = req.params?.id ?? req.data.id;
	const requestOptions = {
		method: 'PUT',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ ...req.data }),
	};
	return fetch(endpoints.RETAIL_MENU, requestOptions).then(handleResponse);
}

function viewMenu({ req }) {
	const url = toQueryStringURL(endpoints.RETAIL_MENU, { ...req.params });
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listMenus({ req }) {
	// Optional ?storeId filter is passed through via params.
	const params = { ...req.params };
	delete params.id;
	const url = toQueryStringURL(endpoints.RETAIL_MENU, params);
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function deleteMenu({ req }) {
	const url = toQueryStringURL(endpoints.RETAIL_MENU, { id: req.params?.id });
	const requestOptions = {
		method: 'DELETE',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default retailMenuServices;
